import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/link.svg";
var LinkOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  LinkOutline_default as default
};
